import { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';
import { cn } from '@/lib/utils';

/**
 * 本地二维码渲染 — 用 `qrcode` 库把内容画到 <canvas>,**全程在浏览器内完成**,
 * 不向任何第三方(如 api.qrserver.com)发送 TOTP 密钥 / otpauth URI。
 *
 * 用于 TOTP 绑定:把 otpauth://totp/... 渲染成二维码供 Authenticator 扫码。
 */
export function QrCanvas({
  value,
  size = 160,
  className,
}: {
  value: string;
  size?: number;
  className?: string;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !value) return;
    let cancelled = false;
    QRCode.toCanvas(canvas, value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#000000', light: '#ffffff' },
    })
      .then(() => {
        if (!cancelled) setError(null);
      })
      .catch((e: unknown) => {
        if (!cancelled) setError(e instanceof Error ? e.message : '二维码生成失败');
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (error) {
    return (
      <div
        className={cn('flex items-center justify-center rounded bg-bg-3 text-xs text-down', className)}
        style={{ width: size, height: size }}
      >
        二维码生成失败
      </div>
    );
  }

  return <canvas ref={canvasRef} width={size} height={size} className={cn('rounded', className)} aria-label="TOTP 二维码" />;
}
